import styled from 'styled-components';

import { IconCheckmarkCircleOutline, token, spaceMixin } from '@zillow/constellation';

export const StyledIcon = styled(IconCheckmarkCircleOutline)`
    && {
        color: ${token('colors.green400')};
        height: 100px;
        width: 100px;
        margin-bottom: ${spaceMixin('xs')};
    }
`;
